<template>
  <div style="background-color: rgb(242,246,249);padding: 0.5rem">
    <div   class="top_outside_box">
      <el-row   class="el_row_top">
        <el-col :xs="24" :sm="4" :md="4" :lg="3" :xl="3">
          <div class="grid-content  image_box">
            <div class="image_background_box">
              <img :src="logoImg" style="width: 80%;height: 6rem;">
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="9" :md="8" :lg="8" :xl="9">
          <div class="grid-content ">
            <div class="top_word_box">
              <div class="app_name_box">
                <span style="font-size: 1.5rem;font-weight: 600;">{{ appName }}</span>
                <span class="header_small_box">官网</span>
              </div>
              <div class="app_name_box middle_start_box">
                <img src="../assets/index/star1.png" v-for="item in 4" :key="item" style="width: 1.3rem;height: 1.3rem"/>
                <img src="../assets/index/star2.png" style="width: 1.3rem;height: 1.3rem"/>
                <span class="image_start_span">4.9分</span>
              </div>
              <div class="app_name_box bottom_word_box" >
                <p class="word_bottom_style">251万下载 · 28.6M · 无广告</p>
                <p class="word_bottom_style">分类： <span style="border:1px solid #999;padding: 0 0.4rem">生活</span></p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="11" :md="12" :lg="13" :xl="12">
          <div class="grid-content  right_button_box">
            <a class="header_btn_class" :href="downloadPath">安装到手机</a>
            <a class="header_btn_class" :href="downloadPath">立即下载</a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="middle_outside_box">
      <div class="image_box_center">
        <img v-for="(item,index) in appImgArr" :key="index" :src="item.photo" class="app_image_style"/>
      </div>
      <p style="font-size: 1.25rem;font-weight: 600;padding: 0.5rem 0.5rem">应用信息</p>
      <p style="font-size: 0.85rem;padding: 0  0.5rem 1rem" v-if="oneWord">{{ oneWord }}</p>
<!--      <p style="font-size: 0.85rem;padding: 0 0.5rem" v-else>找兼职就用{{ appName }}软件！</p>-->
      <p style="font-size: 0.85rem;padding: 0 0.5rem 1rem" v-if="towWord" v-html="towWord"></p>
<!--      <p style="font-size: 0.85rem;padding: 0.5rem 0.5rem" v-else>-->
<!--        {{ appName }}是一款能够让你轻松兼职的网络兼职手机应用。满足在校大学生，居家宝妈和上班族利用空闲时间兼职的需求，众多名气直聘的兼职岗位，并提供满意可靠服务的互联网兼职的垂直平台。以众多优质兼职资源为依托，为兼职者提供人性化，个性化，专业化的兼职信息服务，让兼职者和优秀企业都能及时解决个人所需达成合作，让每一次兼职变得更便捷，更愉悦！</p>-->
    </div>
    <div class="bottom_outside_box">
      <span class="bottom_span_one">版权所有：{{ company }}</span>
      <span class="bottom_span_tow">备案号：<a href="https://beian.miit.gov.cn" target="_blank" style="font-size: 0.85rem;color: #666">{{ icpNum }}</a></span>
    </div>
  </div>


</template>

<script>
export default {
  name: "base",
  data(){
     return{

     }
  },
  props:{
    logoImg:{
      type:String
    },
    appImgArr:{
      type:Array
    },
    appName:{
      type:String
    },
    company:{
      type:String
    },
    icpNum:{
      type:String
    },
    downloadPath:{
      type:String
    },
    oneWord:{
      type:String
    },
    towWord:{
      type:String
    }
  }
}
</script>

<style scoped>

.top_outside_box{
  width: 72%;
  height: 10.5rem;
  margin: 1rem auto;
  background-color: white;
}

.grid-content {
  min-height: 7.5rem;
}
.image_box{
  display: flex;
  align-items: center;
  justify-content: end;
}
.image_background_box{
  width: 92%;
  height: 7.5rem;
  background-color: rgb(244,244,244);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.63rem;
}
.top_word_box{
  width: 100%;
  margin-left: 1rem;
}
.app_name_box{
  width: 100%;
  height: 2.5rem;
}
.header_small_box{
  width: 1.6rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.8rem;
  border: 1px solid #267DEB;
  color: #267DEB;
  padding: 0 4px;
  margin-left: 0.8rem;
}
.middle_start_box{
  display: flex;
  align-items: center;
}
.image_start_span{
  font-size: 1.3rem;
  margin-left: 1rem;
}
.bottom_word_box{
  width: 17rem;
  display: flex;
  justify-content: space-between;
}
.word_bottom_style{
  color: #999;
  font-size: 0.85rem;
}
.right_button_box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}
.header_btn_class{
  width: 9rem;
  height: 3rem;
  font-size: 1.25rem;
  color: white;
  background-color: var(--downBtn);
  margin: 0.5rem 0;
  text-align: center;
  line-height: 3rem;
  text-decoration: none;
}
.el_row_top{
  padding: 1.5rem;
}
.middle_outside_box{
  width: 72%;
  min-height: 20rem;
  background-color: white;
  margin: 0 auto;
}
.app_image_style{
  width: 23%;
  height: 85%;
  padding: 0 0.35rem;
}
.bottom_outside_box{
  width: 100%;
  height: 5%;
  padding: 2rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom_span_one{
  font-size: 0.85rem;
  color: #666;
}
.bottom_span_tow{
  font-size: 0.85rem;
  padding-left: 6rem;
  color: #666;
}
.middle_outside_box{
  padding: 0.8rem 0;
}
@media (min-width: 1200px) {
  .image_background_box{
    width: 73%;
  }
}
@media  (min-width: 979px) and (max-width: 1200px)  {
  .top_outside_box{
    width: 100%;
  }
  .middle_outside_box{
    width: 100%;
  }
}

/* 平板电脑和小屏电脑之间的分辨率 */
@media (min-width: 768px) and (max-width: 979px) {
  .top_outside_box{
    width: 100%;
  }
  .middle_outside_box{
    width: 100%;
  }
  .app_image_style{
    height: 80%;
  }
}

/* 横向放置的手机和竖向放置的平板之间的分辨率 */
@media (max-width: 767px) {
  .top_outside_box{
    width: 100%;
    height: auto;
  }
  .image_box{
    height: 8rem;
    justify-content: center;
  }
  .image_background_box{
    width: 17.35%;
  }
  .el_row_top{
    padding: 0;
  }
  .app_name_box{
     display: flex;
    align-items: center;
    justify-content: center;
  }
  .right_button_box{
    align-items: center;
  }
  .header_btn_class:nth-last-child(1){
    display: none;
  }
  .bottom_word_box{
    width: 100%;
    justify-content: space-between !important;
  }
  .image_background_box{
    width: 7rem;
    height: 7rem;
  }
  .middle_outside_box{
    width: 100%;
    overflow: hidden;
    overflow-x: auto;
  }
  .app_image_style{
    width: 10rem;
    height: 80%;
  }
  .image_box_center{
    display: flex;
    overflow-x: auto;
  }
}

/* 横向放置的手机及分辨率更小的设备 */
@media (max-width: 480px) {
  .top_outside_box{
    width: 100%;
  }
  .image_background_box{
    width: 7rem;
    height: 7rem;
  }
  .middle_outside_box{
    width: 100%;
  }
  .app_image_style{
    height: 80%;
  }
  .bottom_outside_box{
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .bottom_span_tow{
    padding-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/baseWeb.vue